<template>
  <div class="section">

    <div class="container auth-container">
      <h2 class="title is-4">{{$t('ui.welcome')}}</h2>

      <div class="field mt-1-half">
        <div class="control">
          <button
            class="button is-outlined  is-fullwidth"
            :disabled="isLoading"
            @click="googleSignIn"
          >
             <span class="icon is-left">
                <i class="mdi mdi-google mdi-16px"></i>
              </span>
            <span style="padding-left: 4px">{{ $t('auth.signInWithGoogle') }}</span>
          </button>
        </div>
      </div>

       <div class="field mt-1">
          <div class="control">
            <button
              disabled
              class="button is-outline is-default-size  is-fullwidth has-icons-left"
              @click="facebookSignIn" :class="{ 'is-loading': isLoading }"
            >
              <span class="icon is-left">
                <i class="mdi mdi-facebook mdi-16px"></i>
              </span>
              <span>{{$t('auth.signInWithFacebook')}}</span>
            </button>
          </div>
        </div>

      <hr class="hr-text" :data-content="$t('ui.or')" />

      <article class="message is-danger mt-1" v-if="isErr">
        <div class="message-body">{{ errMsg }}</div>
      </article>

      <form @submit.prevent="signIn" class="auth-form">
        <!-- email -->
        <div class="field">
          <!-- <label class="label">{{$t('auth.email')}}</label> -->
          <div class="control has-icons-right">
            <input
              class="input "
              :class="{ 'is-danger': isEmailErr }"
              type="email"
              :placeholder="$t('auth.enterYourEmail')"
              v-model="account.email"
              @input="resetErrs"
              @focus="hideBottomNavbar(true)"
              @blur="hideBottomNavbar(false)"
              autocomplete="on"
              required
            />
            <span class="icon is-small is-right">
              <!-- <img src="@/assets/svg/outline-email.svg" alt=""> -->
              <i class="mdi mdi-email-outline mdi-16px"></i>
            </span>
          </div>
          <p class="help is-danger" v-show="isEmailErr">{{emailErrMsg}}</p>
        </div>
        <!-- ./email -->

        <!-- password -->
        <div class="field">
          <!-- <label class="label">{{ $t('auth.password') }}</label> -->
          <div class="control has-icons-right">
            <input
              class="input "
              :class="{ 'is-danger': isPwErr }"
              type="password"
              name="password"
              @input="resetErrs"
              @focus="hideBottomNavbar(true)"
              @blur="hideBottomNavbar(false)"
              :placeholder="$t('auth.enterYourPassword')"
              v-model="account.password"
              autocomplete="on"
              required
            />
            <span class="icon is-small is-right">
              <i class="mdi mdi-lock-outline mdi-16px"></i>
              <!-- <img src="@/assets/svg/outline-https.svg" alt=""> -->
            </span>
            <p class="help is-danger" v-show="isPwErr">{{pwErrMsg}}</p>
          </div>
        </div>
        <!-- ./password -->

        <div class="field">
          <div class="control">
            <label class="checkbox ">
              <input type="checkbox" />
              {{ $t('auth.rememberMe') }}
            </label>
          </div>
        </div>

        <div class="field mt-1">
          <div class="control">
            <button
              class="button  is-primary is-default-size is-fullwidth"
              :class="{ 'is-loading': isLoading }"
            >{{ $t('auth.logIn') }}</button>
          </div>
        </div>
      </form>
    </div>

    <p class="has-text-centered mt-1" style="font-size: 14px;">
      <router-link :to="{ name: 'reset-pw' }">{{ $t('auth.forgotPassword') }}</router-link>
    </p>
    <p class="has-text-centered mt-1 is-size-6">
      {{ $t( 'auth.dontHaveAccount', { msg: $store.state.appName }) }} 
      <router-link  :to="{ name: 'signup' }">{{ $t('auth.signUp') }}</router-link>
    </p>
  </div>
</template>

<script>
import { auth } from "@/fireinit";
import { mapMutations } from "vuex";

export default {
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Giris Yap",
    // all titles will be injected into this template
    titleTemplate: `%s`,
    
  },
  data() {
    return {
      account: {
        email: "",
        password: ""
      },
      isErr: false,
      errMsg: "",
      isPwErr: false,
      pwErrMsg: "",
      isEmailErr: false,
      emailErrMsg: "",
      isLoading: false
    };
  },
  methods: {
    ...mapMutations({
      hideBottomNavbar: "ui/SET_HIDE_BOTTOM_NAVBAR"
    }),
    resetErrs() {
      this.isEmailErr = false;
      this.isPwErr = false;
      this.isErr = false;
      this.errMsg = "";
    },
    async signIn() {
      this.isLoading = true;
      this.isErr = "";
      this.errMsg = "";
      try {
        await this.$store.dispatch("auth/signIn", this.account);
        // if (this.isErr) return;
        this.$router.push("/");
      } catch (error) {
        if (error.code === "auth/user-not-found") {
          this.isEmailErr, (this.isErr = true);
          this.errMsg =
            "Bu e-posta adresine kayıtlı bir kullanıcı bulunamadı. Lütfen, e-posta adresinizi kontrol edip tekrar deneyin.";
        } else if (error.code === "auth/wrong-password") {
          this.isPwErr, (this.isErr = true);
          this.pwErrMsg, (this.errMsg = "Hatalı şifre girdiriniz");
        } else {
          this.isErr = true;
          this.errMsg =
            "İşleminiz gerçekleştirilemedi. Lütfen tekrar giriş yapmayı deneyin.";
        }
      }
      this.isLoading = false;
    },
    googleSignIn() {
      // console.log('google sign in')
      this.$store.dispatch('auth/googleSignIn')
    },
       facebookSignIn() {

    },
  },

  beforeRouteEnter(to, from, next) {
    if (auth.currentUser && !auth.currentUser.isAnonymous) {
      next({ name: "user-profile", params: { userId: auth.currentUser.uid } });
    } else {
      next();
    }
  }
};
</script>

